var map = {
	"./Bronze Award 2025.png": "bbd1",
	"./IRISi.png": "7063",
	"./LGBT.png": "053b",
	"./NIHRlogo.png": "7cef",
	"./aboutus.svg": "7cb4",
	"./active-tick.svg": "5f94",
	"./addbtn.svg": "02d8",
	"./addbtngreen.svg": "cf0b",
	"./alerts.svg": "c04d",
	"./analytics-blue 2.svg": "d14e",
	"./analytics-blue.svg": "8a0b",
	"./analytics.svg": "2f00",
	"./android-chrome-256x256.png.ico": "c156",
	"./anima.png": "5aaf",
	"./appointments.svg": "4dcb",
	"./appstore.svg": "40be",
	"./authentication-bg.jpg": "913f",
	"./avatar-man.svg": "5bf3",
	"./banners.svg": "9e0d",
	"./bell.svg": "3845",
	"./brands/bitbucket.png": "16ae",
	"./brands/dribbble.png": "ddfc",
	"./brands/dropbox.png": "aee3",
	"./brands/github.png": "866f",
	"./brands/mail_chimp.png": "8f44",
	"./brands/slack.png": "4f43",
	"./calendar.svg": "d71f",
	"./cancel-appointments.svg": "65e6",
	"./carer_info.svg": "d5d4",
	"./check-box.svg": "20ec",
	"./clinics_and_services.svg": "d983",
	"./comingsoon-bg.jpg": "cfce",
	"./comm_welbeing.svg": "c218",
	"./common_ailments.svg": "6b10",
	"./companies/img-1.png": "0bcf",
	"./companies/img-2.png": "551f",
	"./companies/img-3.png": "3c22",
	"./companies/img-4.png": "502e",
	"./companies/img-5.png": "df2d",
	"./companies/img-6.png": "f035",
	"./companies/img-7.png": "32fe",
	"./companies/img-8.png": "f144",
	"./contactus.svg": "7301",
	"./cqc.svg": "2e83",
	"./cricklewood.png": "3799",
	"./cronic-disease.svg": "45f5",
	"./cross_gray.svg": "88dc",
	"./cross_gray2.svg": "c3d1",
	"./cross_green.svg": "dbe7",
	"./cross_red.svg": "daa8",
	"./customer-support.svg": "b601",
	"./dashboard.svg": "0855",
	"./delbtn.svg": "f7d0",
	"./dementia-friendly.png": "3bc0",
	"./docman-icon.png": "305d",
	"./document-icon-blue.svg": "9559",
	"./document-icon-white.svg": "8992",
	"./documents.svg": "b14e",
	"./doublelayout.svg": "bab3",
	"./download.svg": "c482",
	"./dr-azim.png": "6f63",
	"./econsult.svg": "6f4fd",
	"./emis-icon.png": "b86a",
	"./error-img.png": "7f6b",
	"./extendedhours.svg": "bd9c",
	"./facebook-icon.svg": "d4fd",
	"./faqs.svg": "8cf0",
	"./favicon.ico": "fbec",
	"./favicon.png": "8925e",
	"./featured-star.svg": "b293",
	"./feedback.svg": "c40c",
	"./feedback1.svg": "cdfe",
	"./feedback2.svg": "0b00",
	"./feedback3.svg": "ec5a",
	"./file-upload-logo.svg": "be57",
	"./flags/arabic.png": "75842",
	"./flags/chaina.png": "326d",
	"./flags/french.jpg": "570f",
	"./flags/germany.jpg": "8a5d",
	"./flags/italy.jpg": "12db",
	"./flags/russia.jpg": "de9d",
	"./flags/select2/ak.png": "8da0",
	"./flags/select2/ca.png": "4a8b",
	"./flags/select2/hi.png": "52ff",
	"./flags/select2/nv.png": "9aaf",
	"./flags/select2/or.png": "2078",
	"./flags/select2/wa.png": "c738",
	"./flags/spain.jpg": "b084",
	"./flags/us.jpg": "b140",
	"./footer.svg": "c71f",
	"./gambling.png": "9941",
	"./general.svg": "8460",
	"./get_u_better.png": "fba5",
	"./globe-white.svg": "f75b",
	"./globe.svg": "5cb9",
	"./good.svg": "ecde",
	"./googleplay.svg": "60f2",
	"./green-fields.png": "f4b7",
	"./greenimpactpioneer.png": "c3ec",
	"./health_wealth.png": "d65c",
	"./health_wellbeing.svg": "bc45",
	"./healthier_together.png": "c5b6",
	"./hill-view.png": "4ae1",
	"./home.svg": "c6c2",
	"./ht-icon.png": "a368",
	"./icb.svg": "2f95",
	"./imagetext.svg": "3376",
	"./info.svg": "db39",
	"./instagram-icon.svg": "aabc",
	"./job-vacancies.svg": "1225",
	"./jointhepractice.svg": "e576",
	"./landingpage.svg": "dd9d",
	"./laptop-icon.svg": "859b",
	"./layouts.zip": "ad94",
	"./layouts/layout-1.jpg": "752a",
	"./layouts/layout-2.jpg": "9d24",
	"./layouts/layout-3.jpg": "db58",
	"./layouts/layout-4.jpg": "81db",
	"./layouts/layout-5.jpg": "79ec",
	"./layouts/layout-6.jpg": "9fa6",
	"./leaflet/marker-icon.png": "2bf7",
	"./learning-disability-friendly.png": "cd1e",
	"./lin_icon.svg": "6d66",
	"./location.svg": "3589",
	"./lock-white.svg": "0465",
	"./lock.svg": "d3cc",
	"./logo-dark-old.png": "60de",
	"./logo-dark.png": "59da",
	"./logo-light-old.png": "3bd8",
	"./logo-light-sm.png": "898a",
	"./logo-light.png": "ea27",
	"./logo-sm-dark.png": "930c",
	"./logo-sm-light.png": "a548",
	"./mail.svg": "999f",
	"./mail_settings.svg": "7dd2",
	"./maintenance-bg.png": "2ef0b",
	"./meeting_and_events.svg": "f021",
	"./meeting_and_events_blue.svg": "b612",
	"./meeting_minutes.svg": "8a38",
	"./meetings-events-icon.svg": "bd13",
	"./megamenu-img.png": "2411",
	"./member_practices.svg": "9731",
	"./mobile-white.svg": "124b",
	"./mobile.svg": "2530",
	"./network.svg": "294e",
	"./network_news.svg": "d1f5",
	"./network_videos.svg": "0c81",
	"./neurodiversity.svg": "d30b",
	"./new-staff-member.png": "ab6e",
	"./newlogo.svg": "c991",
	"./news.svg": "8025",
	"./nhs.png": "4733",
	"./nither.svg": "fdbd",
	"./no-image.svg": "2ec6",
	"./nonnhsfees.svg": "7f56",
	"./online_services.svg": "4dc1",
	"./opening_hours.svg": "76e1",
	"./others.svg": "b855",
	"./pages.svg": "e678",
	"./parkrun.png": "f98e",
	"./patchs.svg": "7f9c",
	"./patient-assist.svg": "7eb2",
	"./patient-voice.svg": "aa3f",
	"./patientassist.svg": "71c3",
	"./patientgroup.svg": "41e6",
	"./pcn-home-banner.png": "391b",
	"./pcn-info.svg": "4506",
	"./pcn-staff-icon.svg": "9371",
	"./pcnoverview.svg": "dd0a",
	"./pcnservices.svg": "0306",
	"./pcnteam.svg": "7aad",
	"./pen-icon.svg": "3abd",
	"./pennine-drive.png": "8cce",
	"./permissions.svg": "ed23",
	"./pheonix-practice.png": "9df3",
	"./play-btn-blue.svg": "8497",
	"./play-btn.svg": "1e9d",
	"./pllogo.svg": "de50",
	"./poor.svg": "6de2",
	"./practice-pol.svg": "21d3",
	"./practice.svg": "e83e",
	"./practice_team.svg": "ee86",
	"./practices_blue.svg": "576e",
	"./prescription.svg": "280e",
	"./preview.svg": "de4f",
	"./privacy.svg": "f9ae",
	"./product/img-1.png": "c080",
	"./product/img-2.png": "2a0c",
	"./product/img-3.png": "8416",
	"./product/img-4.png": "516e",
	"./product/img-5.png": "2acb",
	"./product/img-6.png": "8b3b",
	"./pv-add.svg": "7aba",
	"./pv-chat-green.svg": "8dd2",
	"./pv-chat.svg": "dd33",
	"./pv-remove.svg": "61c1",
	"./pv-search.svg": "cd23",
	"./query-icon-blue.svg": "eb4a",
	"./query-icon-white.svg": "a28f",
	"./quicklinks.svg": "5032",
	"./rapidhealth.svg": "ad65",
	"./ravenscroft.png": "5472",
	"./reception.svg": "bbc3",
	"./recommendedapps.svg": "7f95",
	"./revert-stick.svg": "357e",
	"./safeplace.png": "92bf",
	"./safesurgery.png": "ebf8",
	"./self_referral.svg": "6c05",
	"./self_referrals.svg": "33e6",
	"./service-added.png": "3a52",
	"./settings.svg": "09a5",
	"./sicknotes.svg": "05d9",
	"./singlelayout.svg": "bea6",
	"./small/img-1.jpg": "19b7",
	"./small/img-2.jpg": "88e3",
	"./small/img-3.jpg": "b168",
	"./small/img-4.jpg": "134b",
	"./small/img-5.jpg": "bb17",
	"./small/img-6.jpg": "3f9c",
	"./small/img-7.jpg": "cf63",
	"./smiley.svg": "d443",
	"./social_media.svg": "b3f0",
	"./st-georges.png": "4345",
	"./staff-availability.svg": "a9eb",
	"./status-tick.svg": "c1b1",
	"./status_fail.svg": "d32a",
	"./strick-icon.svg": "1a2da",
	"./support-icon.svg": "6b9a",
	"./support.svg": "85fe",
	"./sustainable_general_practice.png": "931a",
	"./tablet-white.svg": "2e7e",
	"./tablet.svg": "d724",
	"./teams-icon.svg": "1b50",
	"./tests_results.svg": "edd5",
	"./textimage.svg": "b18e",
	"./tick_gray.svg": "3d98",
	"./tick_gray2.svg": "da93",
	"./tick_green.svg": "825e",
	"./tick_red.svg": "7158",
	"./training.svg": "9dec",
	"./triple.svg": "7052",
	"./troubleshooting-icon.svg": "40d0",
	"./twitter-icon.svg": "cc3c",
	"./user_icon.svg": "6d87",
	"./users.svg": "4e3e",
	"./users/avatar-1.jpg": "c3eb",
	"./users/avatar-2.jpg": "95f5",
	"./users/avatar-3.jpg": "61ae",
	"./users/avatar-4.jpg": "1f62",
	"./users/avatar-5.jpg": "a8a4",
	"./users/avatar-6.jpg": "d03b",
	"./users/avatar-7.jpg": "cd5e",
	"./users/avatar-8.jpg": "9f20",
	"./verygood.svg": "3aa9",
	"./verypoor.svg": "7f7f",
	"./veteran-friendly.png": "5c5b",
	"./whatisapcn.svg": "61a7",
	"./yellowfewerzone.png": "8370",
	"./youtube-icon.svg": "eb50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";